import { Movax } from './Movax';
const Mustache = require('mustache');
import { SparePartCartContact } from './sparePartContactForm';

export class SparePartCart {
  private ajaxEndpoint: string;
  private formSelector: string;
  private removeButtonSelector: string;
  private language: string;
  private cartForms;
  private cartItemRemoveButtons
  private minicart: Element;
  private clearCartButton: Element;
  private minicartTextContainer: Element;
  private updateCartButton: Element;
  private sparePartContactForm: SparePartCartContact = new SparePartCartContact();

  constructor() {
    this.ajaxEndpoint = '/stage-ajax/sparepart_cart/';

    //this class and data-form attribute should be added to all cart functionality forms
    this.formSelector = '.js-sparepart-cart-form';
    this.removeButtonSelector = '.js-sparepart-cart-remove-button';
    this.cartForms = Array.from(document.querySelectorAll(this.formSelector));
    this.minicart = document.querySelector('.js-minicart');
    this.minicartTextContainer = document.querySelector('.js-sparepart-minicart-text');
    this.language = document.documentElement.lang;
  }

  /**
   * Attach/update event listeners
   * This can be used after dom updates
   */
  public attachListeners() {
    this.attachInputChange();

    //optional - might get removed
    this.clearCartButton = document.getElementById('clear-cart');
    if(this.clearCartButton){
      this.clearCartButton.addEventListener('click', () => {
        this.clearCart();
      });
    }

    //cart page - update cart button
    this.updateCartButton = document.getElementById('js-update-cart');

    if(this.updateCartButton){
      this.updateCartButton.addEventListener('click', this.updateHandler.bind(this), false)
    }

    //cart item remove buttons
    this.attachRemoveButtons();

  }

  /**
   * form submit handler
   * @param event
   */
  public formHandler(event) {
    this.formSubmission(event);
  }

  /**
   * update cart button click handler
   */
  public updateHandler() {
    const self = this;
    self.updateToCart(self.cartForms);
  }

  public removeButtonHandler () {
    const button = event.currentTarget as HTMLFormElement;
    const itemId = button.getAttribute('data-item');
    this.cartItemRemove(itemId);
  }

  /**
   * Handle form submission
   * @param event submission event
   */
  private async formSubmission(event:Event) {
    event.preventDefault();
    const form = event.currentTarget as HTMLFormElement;
    const formIdentifier = form.getAttribute('data-form');

    const myFormData = new FormData(form);
    myFormData.append('language', this.language);
    const params = {};
    myFormData.forEach((value, key) => {
      params[key] = value;
    });

    switch(formIdentifier) {
      case 'addToCart':
        this.addToCart(params, form);
        break;
    }
  }

  /**
   * Post data to cart and update minicart
   * @param params form data
   * @param form form that handless the submission
   */
  public async addToCart(params:object, form) {
    const errorContainer = form.querySelector('.js-form-error');
    errorContainer.innerHtml = '';
    const submitBtn = form.querySelector('button[type=submit]');
    submitBtn.classList.add('button--loading');

    try {
      const result = await this.makeAjaxRequest(params);
      if(result.status === 'error') {
        throw new Error (result.message);
      }
      this.updateMinicart();
    } catch (error) {
      errorContainer.innerHtml = 'Error: ' + error.message;
    } finally {
      submitBtn.classList.remove('button--loading');
    }
  }

  /**
   * Remove item from cart
   *
   * @param itemId
   */
  public async cartItemRemove(itemId: string){

    const params =  {
      action   : 'removeItem',
      item     : itemId,
      language : this.language
    };

    try {
      const result = await this.makeAjaxRequest(params);
      this.updateCartSummary(result.totalPrice);
      this.updateCartView(result.items);

    } catch (error) {
      //TODO something something error flynn

    } finally {
        //get the remaining remove buttons
      this.attachRemoveButtons();
    }
  }


  /**
   * attach cart item remove buttons
   *
   */
  public attachRemoveButtons() {
    this.cartItemRemoveButtons = Array.from(document.querySelectorAll( this.removeButtonSelector ));
    //reattach listeners
    if(this.cartItemRemoveButtons) {
      this.cartItemRemoveButtons.forEach( button => {
        button.addEventListener('click' , this.removeButtonHandler.bind(this), false);
      });
    }
  }

  /**
   * update cart items and update cart summary
   * @param forms - all forms in cart (items)
   *
   */
  public async updateToCart(forms: any) {

    const errorContainer = document.querySelector('.js-cart-error');

    this.updateCartButton.classList.add('button--loading');

    const items = [];

    this.cartForms = Array.from(document.querySelectorAll(this.formSelector));//include possible new forms
    this.cartForms.forEach(form => {
      const myFormData = new FormData(form);
      const formData = {};
      myFormData.forEach((value, key) => {
        formData[key] = value;
      });
      items.push(formData);
    });

    const params =  {
      action   : 'updateCart',
      items    : JSON.stringify(items),
      language : this.language
    };

    try {
      const result = await this.makeAjaxRequest(params);
      this.updateCartSummary(result.totalPrice);
      this.updateCartView(result.items);

      if(result.status !== 'success'){
        errorContainer.innerHTML = result.message;
      }

    } catch (error) {

      errorContainer.innerHTML = JSON.stringify(error);

    } finally {
      this.updateCartButton.classList.remove('button--loading');
    }

  }

  /**
   * update Cart view
   * @param items
   */
  public async updateCartView(items:any) {
    const shopCartContainer = document.getElementById('js-shopping-cart');
    const shopCartTemplate = document.getElementById('js-sparepart-shopping-cart-template').textContent;

    //create the cart DOM from template and new data
    const cartMarkup = Mustache.render(shopCartTemplate,{items : items?.data?.items, showOverBalance: items?.showOverBalance });
    const cart = document.createElement('div');
    cart.setAttribute('id','js-shopping-cart');
    cart.classList.add('sparepart-cart');
    cart.innerHTML = cartMarkup;
    document.querySelector('.js-sparepart-cart-controls-update').classList.remove('container-visible')

    //replace container with new cart
    shopCartContainer.replaceWith(cart);
    this.attachRemoveButtons();
    this.attachInputChange();
  }

  /**
   * Attach listeners to amount inputs
   */
  public async attachInputChange() {
    this.cartForms = Array.from(document.querySelectorAll(this.formSelector));//include possible new forms

    this.cartForms.forEach(form => {
      form.addEventListener('submit',  this.formHandler.bind(this) );
      form.querySelectorAll('input[type="number"]').forEach((input) => {
        input.addEventListener('change', () => {
          document.querySelector('.js-sparepart-cart-controls-update').classList.add('container-visible');
        });
      });
    });
  }

  /**
   * Update cart summary
   *
   * @param totalPrice -  has "totalPrice" of cart
   */
  public async updateCartSummary(totalPrice:any) {
    const summaryTemplate = document.getElementById('js-sparepart-cart-summary').textContent;
    const summaryContainer = document.getElementById('cart-summary');

    const totalSum = document.getElementById('js-total-price');
    totalSum.innerHTML = totalPrice;
  }


  /**
   * Update minicart
   */
  public async updateMinicart() {
    this.minicart.classList.add('cart-visible');
    this.minicartTextContainer.classList.remove('shake-once');
    const cartContent = await this.getCartContent();
    if(cartContent.status !== 'error' && cartContent.message) {
      this.minicartTextContainer.innerHTML = cartContent.message;
      this.minicartTextContainer.classList.add('shake-once');
    }
  }

  /**
   * Get cart content and item amounts
   * @returns {object} cart data
   */
  public async getCartContent(){
    try {
      const params = {
        action: 'getCartWithAmounts'
      }
      return await this.makeAjaxRequest(params);
    } catch (error) {
    }
  }


  /**
   * Clear cart contents
   * @param params
   *
   */
  public clearCart() {
    try {
      const params = {
        action: 'clearCart'
      }
      return this.makeAjaxRequest(params);
    } catch (error) {

    } finally {
      const shopCartContainer = document.getElementById('js-shopping-cart');
      shopCartContainer.remove();
      this.updateCartButton.remove();
      this.clearCartButton.remove();
      this.updateCartSummary(0);
      this.sparePartContactForm.getFormContainer().remove();
      this.sparePartContactForm.removeContactDetails();//empty invoice and shipping details from local storage
    }
  }


  /**
   * Make ajax request
   * @param params parameters as object or serialized string
   * @returns {object} return object should contain status, message, data
   */
  private async makeAjaxRequest(params:object) {

    if(!this.ajaxEndpoint) {
      throw new Error('Form submission failed. Endpoint undefined.');
    }

    return Movax.xhr.get(this.ajaxEndpoint, params);
  }

}

